/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";

import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idRoletaCheckin: string;
  idCorretorSistemaOrigemAtual: string;
  idCorretorSistemaOrigemNovo: string;
}

export function useBaterMao() {
  const putData = async (props: Props) => {
    const BATER_MAO = `${leadsWebEnviroment}/common/checkin/recepcao/bater-mao/v1`;
    const response = await instance.put(BATER_MAO, {
      idRoletaCheckin: props.idRoletaCheckin,
      idCorretorSistemaOrigemAtual: props.idCorretorSistemaOrigemAtual,
      idCorretorSistemaOrigemNovo: props.idCorretorSistemaOrigemNovo,
    });
    return response?.data?.data;
  };
  const mutation = useMutation({
    mutationFn: putData,
    onSuccess: () => { },
    onError: () => { },
  });

  return mutation;
}
